export default __webpack_public_path__ + "static/media/kalahastiTemple7.214eae36.png";